import { Link } from "react-router-dom";
import { useState } from "react";

export default function SignUp() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [rPass, setRPass] = useState("");

  // const [nameError, setNameError] = useState("");
  // const [emailError, setEmailError] = useState("");
  // const [passError, setPassError] = useState("");
  // const [rPassError, setRPassError] = useState("");

  async function submitFunction(e) {}

  return (
    <div className="s-u-container">
      <div className="box">
        <div className="start-side">
          <Link className="back-home" to="/">
            <i class="fa-solid fa-arrow-left"></i> Home
          </Link>
          <h2>Welcome Back!</h2>
          <p>To keep connected with us please login with your personal info</p>
          <Link to="/login" className="btn btn-reverse" >
            SIGN IN
          </Link>
        </div>
        <div className="end-side">
          <Link className="back-home" to="/">
            <i class="fa-solid fa-arrow-left"></i> Home
          </Link>
          <h2>Create Account</h2>
          <div className="sociel-login">
            <a href="/">
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            <a href="/">
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="/">
              <i className="fa-brands fa-instagram"></i>
            </a>
          </div>
          <p>or use your email for registration:</p>
          <form onSubmit={submitFunction}>
            <div className={`name inp-field`}>
              <i className="fa-regular fa-user"></i>
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
            {/* <p className="error">{nameError}</p> */}
            <div className={`email inp-field `}>
              <i className="fa-regular fa-envelope"></i>
              <input
                type="text"
                placeholder="Email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {/* <p className="error">{emailError}</p> */}
            <div className={`password inp-field `}>
              <i className="fa-solid fa-lock"></i>
              <input
                type="password"
                placeholder="Password"
                name="pass"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
              />
            </div>
            {/* <p className="error">{passError}</p> */}
            <div className={`password inp-field `}>
              <i className="fa-solid fa-lock"></i>
              <input
                type="password"
                placeholder="Repeat Password"
                name="rpass"
                value={rPass}
                onChange={(e) => setRPass(e.target.value)}
              />
            </div>
            {/* <p className="error">{rPassError}</p> */}
            <input className="btn" type="submit" />
          </form>
        </div>
      </div>
    </div>
  );
}
